export const OZ = 'oz';
export const NORMAN = 'norman';